import { render, staticRenderFns } from "./DexSection.vue?vue&type=template&id=18dec4d0"
import script from "./DexSection.vue?vue&type=script&lang=ts"
export * from "./DexSection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports